import {statusColorScheme} from '../../../../constants/statuses';

export function getStatusBorderColor(statusColor: string): string {
    return statusColor === statusColorScheme.colorWhite
        ? statusColorScheme.colorBlack
        : statusColor;
}
